(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-easy-order"] && !Shopify.designMode) return;
  try {
    
  class NativeQuickOrder extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('[data-quantity-input]'));
      this.submitButton = this.querySelector('[data-add-selected]');
      this.countLabel = this.querySelector('[data-selected-count]');
      this.message = this.querySelector('[data-quick-order-message]');
      this.destination = this.dataset.checkoutPath || '/cart';
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('input', this.updateSummary.bind(this));
      this.updateSummary();
    }

    handleClick(event) {
      const minus = event.target.closest('[data-quantity-minus]');
      const plus = event.target.closest('[data-quantity-plus]');
      const submit = event.target.closest('[data-add-selected]');
      const single = event.target.closest('[data-add-single]');
      if (minus || plus) {
        const input = event.target.closest('[data-quick-order-item]').querySelector('[data-quantity-input]');
        const current = Number(input.value) || 0;
        input.value = Math.max(0, current + (plus ? 1 : -1));
        this.updateSummary();
      }
      if (single) {
        this.addSingle(single);
      }
      if (submit) {
        this.addSelected();
      }
    }

    selectedItems() {
      return this.inputs
        .map((input) => ({ id: Number(input.dataset.variantId), quantity: Number(input.value) || 0 }))
        .filter((item) => item.id && item.quantity > 0);
    }

    updateSummary() {
      const total = this.selectedItems().reduce((sum, item) => sum + item.quantity, 0);
      this.countLabel.textContent = total === 1 ? '1 item selected' : `${total} items selected`;
      this.submitButton.disabled = total === 0;
    }

    async addSelected() {
      const items = this.selectedItems();
      if (!items.length) return;
      this.submitButton.disabled = true;
      this.message.textContent = 'Adding your cookies...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart add failed');
        await this.updateCartBubble();
        this.inputs.forEach((input) => {
          input.value = 0;
        });
        this.updateSummary();
        this.message.textContent = 'Added to cart.';
      } catch (error) {
        this.message.textContent = 'Something went wrong. Please try one more time.';
        this.submitButton.disabled = false;
      }
    }

    async addSingle(button) {
      const item = button.closest('[data-quick-order-item]');
      const input = item.querySelector('[data-quantity-input]');
      const id = Number(button.dataset.variantId);
      const quantity = Math.max(1, Number(input.value) || 1);
      if (!id) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      this.message.textContent = 'Adding your cookie...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id, quantity })
        });
        if (!response.ok) throw new Error('Cart add failed');
        await this.updateCartBubble();
        this.animateToCart(item);
        input.value = 0;
        this.updateSummary();
        this.message.textContent = 'Added to cart.';
        button.textContent = 'Added';
        setTimeout(() => {
          button.textContent = 'Add to cart';
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1600);
      } catch (error) {
        this.message.textContent = 'Something went wrong. Please try one more time.';
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    animateToCart(item) {
      const image = item && item.querySelector('.native-easy-order__image');
      const cartLink = document.querySelector('a[href="/cart"], a[href*="/cart"]');
      if (!image || !cartLink || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const imageRect = image.getBoundingClientRect();
      const cartRect = cartLink.getBoundingClientRect();
      const flyingImage = image.cloneNode(true);
      flyingImage.classList.add('native-easy-order__fly-image');
      flyingImage.style.left = `${imageRect.left}px`;
      flyingImage.style.top = `${imageRect.top}px`;
      flyingImage.style.width = `${imageRect.width}px`;
      flyingImage.style.height = `${imageRect.height}px`;
      document.body.appendChild(flyingImage);

      const targetX = cartRect.left + cartRect.width / 2 - imageRect.left - imageRect.width / 2;
      const targetY = cartRect.top + cartRect.height / 2 - imageRect.top - imageRect.height / 2;
      flyingImage.animate(
        [
          { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1 },
          { transform: `translate3d(${targetX * 0.45}px, ${targetY - 90}px, 0) scale(0.72)`, opacity: 0.92 },
          { transform: `translate3d(${targetX}px, ${targetY}px, 0) scale(0.18)`, opacity: 0 }
        ],
        {
          duration: 760,
          easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)'
        }
      ).addEventListener('finish', () => flyingImage.remove());

      cartLink.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.14)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 360,
          delay: 560,
          easing: 'ease-out'
        }
      );
    }

    async updateCartBubble() {
      const bubble = document.querySelector('#cart-icon-bubble');
      if (!bubble) return;
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });
      if (!response.ok) return;
      const cart = await response.json();
      const count = Number(cart.item_count) || 0;
      bubble.innerHTML = count > 0
        ? `<span class="native-easy-order__cart-count" aria-label="${count} cart items">${count}</span>`
        : '';
      bubble.dispatchEvent(new CustomEvent('cart:count-updated', { bubbles: true, detail: { count } }));
    }
  }

  if (!customElements.get('native-quick-order')) {
    customElements.define('native-quick-order', NativeQuickOrder);
  }

  if (!window.nativeLandingCartRedirect) {
    window.nativeLandingCartRedirect = true;

    document.addEventListener(
      'click',
      async (event) => {
        const button = event.target.closest('button.btn--atc[name="add"]');
        if (!button || button.closest('.native-easy-order')) return;
        const form = button.closest('form[action*="/cart/add"]');
        if (!form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const variantInput = form.querySelector('[name="id"]');
        const quantityInput = form.querySelector('[name="quantity"], [name="updates[]"]');
        const id = Number(variantInput && variantInput.value);
        const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
        if (!id) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ id, quantity })
          });
          if (!response.ok) throw new Error('Cart add failed');
          button.disabled = false;
          button.removeAttribute('aria-busy');
        } catch (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          form.submit();
        }
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();
})();
